var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div role=\"region\"></div><footer><div class=\"controls\"></div><div class=\"feedback\"></div></footer>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/views/templates/view_base.jade
 ** module id = 68
 ** module chunks = 0
 **/